$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = -50; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();

        // animation
        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                if ($(this).data("animate-restart") != false) {
                    $(this).removeClass("animateIn--active");
                }
            }
        });

        // countup
        $(".js-countup").each(function () {
            console.log('test');
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop) <= viewPortEnd && (elementBottom) >= viewPortStart) {

                // check for countup - if in viepoint fire countUp (once)
                if (!$(this).hasClass("counted")) {

                    var options = {
                        useEasing: true,
                        useGrouping: true,
                        separator: '.',
                        decimal: '.',
                    };

                    number = $(this).find(".js-countup-number");

                    number.each(function () {
                        // avoid jumping
                        var width = $(this).width();
                        $(this).css("width", width);

                        var counterID = $(this).attr("id");
                        countTo = $(this).data("count");
                        var count = new CountUp(counterID, 0, countTo, 0, 4, options);
                        count.start();
                    });

                    $(this).addClass("counted");
                }
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();








    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-header").toggleClass("show-nav");
        $("body").toggleClass("freeze");
    });

    $(document).on('keydown', function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
            $(this).removeClass("active");
            $(".js-header").removeClass("show-nav");
            $("body").removeClass("freeze");
        }
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this).find(".js-hero-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-hero-slider-dots"),
                prevArrow: $(this).find(".js-hero-slider-prev"),
                nextArrow: $(this).find(".js-hero-slider-next"),
            });
            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-hero-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-header").click(function () {
        $(this).parents(".js-accordion-item").toggleClass("active");
    });

    $(".js-accordion-header").keypress(function (e) {
        if (e.which === 13) { // 13 is the Enter key code
            $(this).click();
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        sessionStorage.setItem('dialogState', true);
        $(this).parents(".js-dialog").get(0).close();
        $("body").removeClass("freeze");
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            sessionStorage.setItem('dialogState', true);
            $(this).get(0).close();
            $("body").removeClass("freeze");
        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog popup
    // *
    // *
    $(".js-contact-popup-open").click(function () {
        openContactPopup();
    })
    $(".js-contact-popup-close").click(function () {
        closeContactPopup();
    })
    var $contactPopup = $(".js-contact-popup");

    function openContactPopup() {
        $contactPopup.get(0).showModal();
        $("body").addClass("freeze");
    }

    function closeContactPopup() {
        $contactPopup.addClass("close");
        $contactPopup.get(0).close();
        $("body").removeClass("freeze");
    }


    // backdrop click
    $(".js-contact-popup").click(function (e) {
        if (e.target === e.currentTarget) {
            closeContactPopup();
        }
    });


    // Event: Callbackform
    $(document).on("submit", ".js-callback-form", function (e) {
        e.preventDefault();

        const formData = new FormData(this);

        $.ajax({
            url: "/assets/components/site/connector.php?action=getcallback",
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {
                console.log("Server response:", response);

            },
            error: function (xhr) {
                console.error("Error:", xhr.responseText);
            }
        });
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentTab
    // *
    // *
    $(".js-tabcontent-nav-item").click(function () {
        var index = $(this).index(),
            $parent = $(this).parents(".js-tabcontent");

        $(this).addClass("active").siblings().removeClass("active");

        $parent.find(".js-tabcontent-content-item").eq(index).addClass("active").siblings().removeClass("active");
        $parent.find(".js-tabcontent-image-item").eq(index).addClass("active").siblings().removeClass("active");
    });

    $(".js-tabcontent-nav-item").keypress(function (e) {
        if (e.which === 13) { // 13 is the Enter key code
            $(this).click();
        }
    });

    if ($(".js-tabcontent").length) {
        $(".js-tabcontent-nav-item").first().trigger("click");
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * caseTeaser
    // *
    // *
    var preFilter = '';

    $(".js-caseteaser-nav-item").click(function () {
        var filter = $(this).data("filter");
        $(this).toggleClass("active").siblings().removeClass("active");

        $(".js-caseteaser-item").removeClass("active").addClass("inactive");

        if (preFilter != filter) {
            $(".js-caseteaser-filter-" + filter).removeClass("inactive").addClass("active");
        } else {
            $(".js-caseteaser-item").removeClass("active inactive");
        }

        preFilter = filter;
    });

    $(".js-caseteaser-nav-item").keypress(function (e) {
        if (e.which === 13) { // 13 is the Enter key code
            $(this).click();
        }
    });

});





// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 50) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }
});

// * * * * * * * * * * * * * * * * * * * * * * * * *
// * heroIntro (Inspiration: https://www.j-k.de/leistungen/webdesign-schorndorf/)
// *
// *
$(window).on("load scroll", function () {
    var scrollPosition = $(window).scrollTop(),
        $heroImage = $(".js-herointro-image"),
        $heroText = $(".js-herointro-text"),
        $heroClaim = $(".js-herointro-claim"),
        animationStepText = 45 - (scrollPosition / 30);


    if (animationStepText <= 1) {
        animationStepText = 1;
        $heroClaim.addClass("active");
        $heroImage.addClass("active");
    } else {
        $heroClaim.removeClass("active");
        $heroImage.removeClass("active");
    }

    $heroText.css("transform", "scale(" + animationStepText);

});


// // * * * * * * * * * * * * * * * * * * * * * * * * *
// // * heroIntro
// // *
// // *
// $(window).on("load scroll", function () {
//     var scrollPosition = $(window).scrollTop(),
//         $heroImage = $(".js-herointro-image"),
//         $heroClaim = $(".js-herointro-claim"),
//         animationStepImage = Math.floor((scrollPosition / 2)),
//         animationStepClaimSpeed = Math.floor((scrollPosition / 8)),
//         animationStepClaim = 100 - Math.floor((scrollPosition / 8));

//     console.log(animationStepClaim);

//     $heroImage.css("transform", "translateY(" + animationStepImage + "px)");
//     $heroClaim.css("opacity", animationStepClaim + "%");
//     $heroClaim.css("transform", "translateY(" + animationStepClaimSpeed + "px)");
// });


// * * * * * * * * * * * * * * * * * * * * * * * * *
// * footer
// *
// *
$(window).on("load scroll", function () {
    var pageHeight = $(document).outerHeight(),
        windowHeight = $(window).outerHeight(),
        footerHeight = $(".js-footer").outerHeight(),
        scrollDistance = pageHeight - (footerHeight / 1.3) - windowHeight,
        scrollPosition = $(window).scrollTop(),
        opacityFooter = (100 - ((((pageHeight - footerHeight) - scrollPosition) * 100) / (footerHeight / 1.3))) / 100,
        opacityPage = ((((pageHeight - footerHeight) - scrollPosition) * 100) / (footerHeight / 1.3)) / 100;

    if (scrollPosition >= scrollDistance) {
        $(".js-footer-background").css("opacity", opacityFooter);
        //$(".js-page-wrapper").css("opacity", opacityPage);
    } else {
        $(".js-footer-background").css("opacity", 0);
        $(".js-page-wrapper").css("opacity", 1);
    }

    if (scrollPosition >= (pageHeight - footerHeight - 150)) {
        $(".js-header").addClass("invert");
    } else {
        $(".js-header").removeClass("invert");
    }
});


// * * * * * * * * * * * * * * * * * * * * * * * * *
// * stickyProjects
// *
// *
$(window).on("load scroll", function () {
    var pageHeight = $(document).outerHeight(),
        windowHeight = $(window).outerHeight(),
        scrollPosition = $(window).scrollTop();

    $(".js-stickyprojects-item").each(function () {
        var itemPosition = $(this).offset().top,
            distance = Math.round(Math.abs((scrollPosition - itemPosition))),
            scale = 1 - (Math.abs(((distance / 3) * 1) / windowHeight));

        if (distance <= windowHeight) {
            $(this).css("transform", "scale(" + scale + ")");
        }
    });



    // if (scrollPosition >= scrollDistance) {
    //     $(".js-footer-background").css("opacity", opacityFooter);
    //     //$(".js-page-wrapper").css("opacity", opacityPage);
    // }else {
    //     $(".js-footer-background").css("opacity", 0);
    //     $(".js-page-wrapper").css("opacity", 1);
    // }

    // if (scrollPosition >= (pageHeight - footerHeight - 150)) {
    //     $(".js-header").addClass("invert");
    // }else {
    //     $(".js-header").removeClass("invert");
    // }
});
